import { useEffect } from "react";
import ReactGA from "react-ga";

export const makePageView = (pageName) => {
  if (window.location.host !== "localhost:44396") {
    console.log("entroooo");
    ReactGA.pageview(pageName);
  }
};

export const useAnalytics = (pageName) =>
  useEffect(() => {
    makePageView(pageName);
  }, [pageName]);
